import styled from 'styled-components';

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  @media (max-width: 768px) {
    position: absolute;
    align-items: unset;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  max-width: 500px;
  width: 90%;
  height: fit-content;

  @media (max-width: 768px) {
    position: relative;
    top: 50vh;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white !important;
  position: relative;

  h1 {
    font-size: 16px !important;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 16px;
  font-size: 1.5rem;
  border: none;
  background: none;
  margin-right: 0 !important;
  cursor: pointer;
`;

export const ChildrenContainer = styled.div`
  margin-top: 24px;
`;